// extracted by mini-css-extract-plugin
export default {"leaderboardTableContainer":"Leaderboard_leaderboardTableContainer__SqsYw","leaderboard":"Leaderboard_leaderboard__WweLd","profit":"Leaderboard_profit__A5d+g"};